import { mergeProps as _mergeProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_input = _resolveComponent("vxe-input");
  return _openBlock(), _createBlock(_component_vxe_input, _mergeProps(_ctx.$attrs, {
    "model-value": $setup.formValue,
    "onUpdate:modelValue": $setup.handleInputChanged
  }), _createSlots({
    _: 2
  }, [_renderList(Object.keys(_ctx.$slots), key => {
    return {
      name: key,
      fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
        key: key
      }, scope))])
    };
  })]), 1040, ["model-value", "onUpdate:modelValue"]);
}